import React from 'react'
import './Card.css'

const Card = ({className,children,...rest}) => {
  return (
    <div className={`cards ${className ?? ''}`} {...rest} >{children}</div>
  )
}

export default Card